import { Skeleton, Stack, Typography } from '@mui/material';
import { _ } from '/@/locale';
import GrowersWithMostRecommendationsDashboard from '../growers-with-most-recommendations';
import MostRecommendedProductsDashboard from '../most-recommended-products';

const RecommendationsSection = ({ userNodeId, year }: { userNodeId?: number; year: number }) => {
    return (
        <>
            <Stack spacing={1}>
                <Typography color='primary' variant='h5'>
                    {_('Recomendaciones')}
                </Typography>
                <Typography color='primary.mui.inactive' variant='body2'>
                    {_(
                        'Te permite ver qué cuáles son los productores con más recomendaciones y que productos se están recomendando'
                    )}
                </Typography>
            </Stack>
            {userNodeId ? (
                <>
                    <MostRecommendedProductsDashboard userNodeId={userNodeId} year={year} />
                    <GrowersWithMostRecommendationsDashboard userNodeId={userNodeId} year={year} />
                </>
            ) : (
                <Skeleton variant='rectangular' height='500px' width='100%' />
            )}
        </>
    );
};

export default RecommendationsSection;
